import { render, staticRenderFns } from "./PermissionsShimmer.vue?vue&type=template&id=62832396&"
import script from "./PermissionsShimmer.vue?vue&type=script&lang=js&"
export * from "./PermissionsShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports